<template>
	<div class="product_info">
        <ProductCard :name='current_product_date.product_name' :isclass='false' :usage='current_product_date.product_usage' :des='current_product_date.product_des' :images='get_product_list(current_product_date.product_image)'></ProductCard>
		<ClassSelectList :show_detail='show_class_detail'></ClassSelectList>
		<CopyrightBottom></CopyrightBottom>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
	import store from '@/store/index.js';
  import wx from 'weixin-js-sdk'; // 引入wxjs

	export default{
		name:"productInfo",
		data(){
			return{
        show_class_detail:true,
				current_product: '',
				current_product_date: {},
				all_date:[]
			}
		},

		computed:{
			allProductDate(){
				return store.state.product_data;
			}
		},
		mounted() {
      this.current_product = this.$route.params.id;
      var self = this;
      if (this.all_date != null) {
          this.all_date.forEach(element => {
              if (element != null) {
                  element.products.forEach(product => {
                      if (product.product_id == self.current_product) {
                          self.current_product_date = product;
                          document.title = product.product_name + '-产品介绍'
                      }
                  })
              }
          });
      }
		},
		methods:{
			get_product_list(product_iamge){
				if (product_iamge != null) {
					return product_iamge.split(",");
				}else{
                    return[];
                }
			}
		},
		watch:{
			$route(){
                this.current_product = this.$route.params.id;
                var self = this;
                if (this.all_date != null) {
                    this.all_date.forEach(element => {
                        if (element != null) {
                            element.products.forEach(product => {
                                if (product.product_id == self.current_product) {
                                    self.current_product_date = product;
                                    document.title = product.product_name + '-产品介绍'
                                    console.log(product)
                                }
                            })
                        }
                    });
                }
			},
			allProductDate:{
				immediate:true,
				deep:true,
				handler:function(newValue,oldValue){
					 var self = this;
					 if (newValue == null || newValue.classes == null) {
						 return
					 }
                     self.all_date = newValue.classes;
                     if (self.all_date != null) {
                        self.all_date.forEach(element => {
                          if (element != null) {
                              element.products.forEach(product => {
                                  if (product.product_id == self.current_product) {
                                      self.current_product_date = product;
                                      document.title = product.product_name + '-产品介绍'
                                  }
                              })
                          }
						});
					}
				 }
			}
		}
	}

</script>

<style type="text/css" scoped>
	.product_info{
		margin-top: 50px;
	}
	ul{
		padding:0px; 
	}
	li{
		list-style-type: none;
	}

	canvas {
		display: block;
		position: absolute;
		bottom: 100px;
		right: -24px;
		z-index: 20;
		cursor: pointer;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
</style>


// WEBPACK FOOTER //
// src/pages/productInfo.vue